"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialSlideSectionNav = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<div class="${x => 'dropup sec-picker' + (x.currentStepIndex === 0 || x.sections.length === 0 ? ' d-none' : '')}">
    <button type="button" class="slide-picker-toggle" @click="${(x, c) => x.toggleMenu(c.event)}" aria-expanded="false" title="${() => 'tutorial.form.sections'.t()}">
        <span class="sp-num"><i class="simple-icon-list"></i></span>
        <span class="sp-text">
            <small>${() => 'tutorial.form.sections'.t()}</small>
            <strong>${x => 'tutorial.form.sectionsCount'.t({ count: x.sections.length })}</strong>
        </span>
        <i class="simple-icon-arrow-down sp-caret"></i>
    </button>
    <ul class="dropdown-menu dropdown-menu-end slide-picker-menu">
        ${(0, fast_element_1.repeat)(x => x.sections, (0, fast_element_1.html) `
        <li>
            <button type="button" class="dropdown-item slide-sec"
                @click="${(section, c) => c.parent.goToSection(c.index)}">
                <span class="sec-num">${(section, c) => c.index + 1}</span>
                <span class="ss-name">${section => section.title || 'tutorial.form.sectionNamePlaceholder'.t()}</span>
                <small>${section => (section.todoItems || []).length} ${() => 'tutorial.form.todoItems'.t()}</small>
            </button>
        </li>
        `, { positioning: true })}
    </ul>
</div>
`;
require("./styles/layout.scss");
const styles = T.css `:host {
  display: contents;
}

.sections-shortcut-panel {
  position: sticky;
  top: 55px;
  background: var(--color-surface, #fff);
  border: 1px solid #e3e6f0;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 12px;
  max-height: calc(100vh - 48px);
  overflow-y: auto;
  min-width: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.sections-shortcut-panel[hidden] {
  display: none;
}
.sections-shortcut-panel .panel-title {
  font-size: 10px;
  font-weight: 600;
  color: var(--color-text-secondary, #6c757d);
  text-align: center;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.sections-shortcut-panel .panel-divider {
  height: 1px;
  background: #e3e6f0;
  margin: 2px 0;
}
.sections-shortcut-panel .section-shortcut-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 84px;
  padding: 8px 6px;
  border: 1px solid #dee2e6;
  background: var(--color-surface, #fff);
  color: var(--color-text-primary, #495057);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}
.sections-shortcut-panel .section-shortcut-btn:hover {
  background: #007bff;
  color: #fff;
  border-color: #007bff;
  transform: translateX(2px);
}
.sections-shortcut-panel .section-shortcut-btn:hover .section-count {
  color: #fff;
}
.sections-shortcut-panel .section-shortcut-btn[active] {
  background: var(--primary-color);
  color: #fff;
  border-color: var(--primary-color);
}
.sections-shortcut-panel .section-shortcut-btn[active] .section-count {
  color: #fff;
}
.sections-shortcut-panel .section-shortcut-btn:active {
  transform: translateX(2px) scale(0.95);
}
.sections-shortcut-panel .section-shortcut-btn .section-number {
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}
@media (max-width: 768px) {
  .sections-shortcut-panel {
    position: static;
    flex-direction: row;
    max-height: none;
    overflow-x: auto;
    align-items: stretch;
  }
  .sections-shortcut-panel .step-shortcut-btn,
  .sections-shortcut-panel .add-step-btn,
  .sections-shortcut-panel .section-shortcut-btn {
    flex-shrink: 0;
  }
  .sections-shortcut-panel .add-step-btn {
    margin-top: 0;
  }
  .sections-shortcut-panel .panel-divider {
    width: 1px;
    height: auto;
    flex-shrink: 0;
  }
}

.sec-picker {
  position: relative;
  flex: 0 1 240px;
  min-width: 0;
  display: flex;
}
.sec-picker.d-none {
  display: none;
}

.slide-picker-toggle {
  width: 100%;
  height: 48px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 12px 0 9px;
  border: 1px solid var(--brand-border);
  border-radius: 10px;
  background: #fff;
  text-align: left;
  color: var(--ink);
  cursor: pointer;
}
.slide-picker-toggle:hover, .slide-picker-toggle[aria-expanded=true] {
  border-color: var(--brand);
}
.slide-picker-toggle .sp-text {
  flex: 1;
}

.slide-picker-menu {
  display: none;
  position: absolute;
  bottom: calc(100% + 8px);
  right: 0;
  width: min(320px, 100vw - 32px);
  max-height: 60vh;
  overflow-y: auto;
  padding: 6px;
  margin: 0;
  border: 1px solid var(--brand-border);
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 -14px 34px -18px rgba(31, 44, 85, 0.35);
  list-style: none;
  z-index: 1050;
}
.slide-picker-menu.show {
  display: block;
}
.slide-picker-menu li {
  list-style: none;
}

.slide-sec {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  text-align: left;
  color: var(--ink);
  white-space: normal;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
}
.slide-sec:hover, .slide-sec:focus {
  background: var(--bg);
  color: var(--ink);
}
.slide-sec small {
  color: var(--muted);
  white-space: nowrap;
}

.sec-num {
  width: 26px;
  height: 26px;
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 50%;
  background: #fff;
  border: 1px solid var(--brand-border);
  color: var(--ink);
  font-weight: 700;
  font-size: 0.78rem;
}

.ss-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ss-name.is-empty {
  color: var(--muted);
  font-weight: 500;
  font-style: italic;
}

.sp-num {
  width: 30px;
  height: 30px;
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: var(--brand-soft);
  color: var(--brand-dark);
  font-weight: 700;
  font-size: 0.82rem;
}

.sp-text {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  line-height: 1.25;
}
.sp-text strong {
  font-size: 0.9rem;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sp-text small {
  color: var(--muted);
  font-size: 0.74rem;
}

.sp-caret {
  color: var(--muted);
  flex-shrink: 0;
}`;
const shadowOptions = { "mode": "open" };
let TutorialSlideSectionNav = class TutorialSlideSectionNav extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.sections = [];
        this.stepIndex = 0;
        this.currentStepIndex = 0;
        this.activeSectionIndex = -1;
        this.observer = null;
        this.setupTimeout = null;
        this.handleOutsideClick = (event) => {
            if (!event.composedPath().includes(this)) {
                this.closeMenu();
            }
        };
    }
    connectedCallback() {
        super.connectedCallback();
        document.addEventListener('click', this.handleOutsideClick);
        this.scheduleSetupObserver();
    }
    disconnectedCallback() {
        var _a;
        super.disconnectedCallback();
        this.clearSetupTimeout();
        (_a = this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.observer = null;
        document.removeEventListener('click', this.handleOutsideClick);
    }
    toggleMenu(event) {
        var _a;
        event.stopPropagation();
        const menu = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.slide-picker-menu');
        menu === null || menu === void 0 ? void 0 : menu.classList.toggle('show');
    }
    closeMenu() {
        var _a;
        const menu = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('.slide-picker-menu');
        menu === null || menu === void 0 ? void 0 : menu.classList.remove('show');
    }
    stepIndexChanged() {
        this.activeSectionIndex = -1;
        this.scheduleSetupObserver();
    }
    currentStepIndexChanged() {
        this.activeSectionIndex = -1;
        this.scheduleSetupObserver();
    }
    sectionsChanged() {
        this.activeSectionIndex = -1;
        this.scheduleSetupObserver();
    }
    clearSetupTimeout() {
        if (this.setupTimeout) {
            clearTimeout(this.setupTimeout);
            this.setupTimeout = null;
        }
    }
    scheduleSetupObserver() {
        this.clearSetupTimeout();
        this.setupTimeout = window.setTimeout(() => {
            this.setupTimeout = null;
            this.setupObserver();
        }, 150);
    }
    getActiveSlide() {
        const root = this.getRootNode();
        const slide = root === null || root === void 0 ? void 0 : root.querySelector('.tutorial-form-slide.slide-step[active]');
        if (slide) {
            return slide;
        }
        return document.querySelector('.tutorial-form-slide.slide-step[active]');
    }
    setupObserver() {
        var _a;
        (_a = this.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
        this.observer = null;
        const slide = this.getActiveSlide();
        if (!slide) {
            console.log('[section-nav] no active slide');
            return;
        }
        const sectionEls = slide.querySelectorAll('.section-edit[data-section-index]');
        console.log('[section-nav] observing', sectionEls.length, 'sections');
        if (sectionEls.length === 0) {
            return;
        }
        this.observer = new IntersectionObserver((entries) => {
            const visible = entries
                .filter(e => e.isIntersecting)
                .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
            if (!visible) {
                return;
            }
            const index = Number(visible.target.getAttribute('data-section-index'));
            console.log('[section-nav] active section', index);
            this.setActiveSection(index);
        }, {
            root: null,
            rootMargin: '-10% 0px -80% 0px',
            threshold: 0
        });
        sectionEls.forEach(el => { var _a; return (_a = this.observer) === null || _a === void 0 ? void 0 : _a.observe(el); });
    }
    setActiveSection(index) {
        if (this.activeSectionIndex === index) {
            this.updateActiveButton(index);
            return;
        }
        this.activeSectionIndex = index;
        this.updateActiveButton(index);
    }
    updateActiveButton(index) {
        var _a;
        const buttons = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelectorAll('.section-shortcut-btn');
        if (!buttons) {
            return;
        }
        buttons.forEach((btn, i) => {
            if (i === index) {
                btn.setAttribute('active', '');
            }
            else {
                btn.removeAttribute('active');
            }
        });
    }
    goToSection(index) {
        this.closeMenu();
        this.setActiveSection(index);
        this.$emit('go-to-section', { sectionIndex: index });
    }
};
exports.TutorialSlideSectionNav = TutorialSlideSectionNav;
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], TutorialSlideSectionNav.prototype, "sections", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialSlideSectionNav.prototype, "stepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialSlideSectionNav.prototype, "currentStepIndex", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], TutorialSlideSectionNav.prototype, "activeSectionIndex", void 0);
exports.TutorialSlideSectionNav = TutorialSlideSectionNav = __decorate([
    (0, client_1.RWSView)('tutorial-slide-section-nav', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], TutorialSlideSectionNav);
TutorialSlideSectionNav.defineComponent();
